import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { skipToken } from '@reduxjs/toolkit/query'
import { clearSelectedId, clearTypeOfShowModalType, selectSelectedId } from '../../../features/modal/modalSlice'
import { useCancelledOrderStatusMutation, useGetOrderByIdQuery, useUpdateStatusOrderMutation } from '../../../features/order/orderApiSlice'
import { showToast } from '../../../toastify/Toast'
import Loading from '../../ui/Loading'
import ErrorMessage from '../../ui/ErrorMessage'
import { formatDate, formatTime } from '../../../utils/formatDateAndTime'
import Checkbox from '../../ui/Checkbox'
import { handleApiError } from '../../../utils/handleApiError'


export default function OrderUpdateModal() {
    
    const dispatch = useDispatch()
    const [selectedTypeOfUpdate, setSelectedTypeOfUpdate] = useState<string>('')
    const orderId = useSelector(selectSelectedId);
    const { data: dataOrderDetails, isError: isErrorOrderDetails, isLoading: isLoadingOrderDetails, refetch: refetchOrderDetails } = useGetOrderByIdQuery(orderId ?? skipToken)
    const [updateStatusOrder, { isLoading: isLoadingUpdateStatusOrder }] = useUpdateStatusOrderMutation();
    // const [cancelledOrder, { isLoading: isLoadingCancelledOrder }] = useCancelledOrderStatusMutation();

    useEffect(() => {
        if (orderId !== null) {
            refetchOrderDetails();
        }
    }, [orderId, refetchOrderDetails]);

    const handleCloseOrderUpdateModal = () => {
        dispatch(clearTypeOfShowModalType())
        dispatch(clearSelectedId());
    }

    const handleUpdateOrderStatus = async (orderId: number) => {

        if(!selectedTypeOfUpdate || orderId === null) {
            return
        }
        try {
            // if(selectedTypeOfUpdate === 'Cancelled') {
            //     await cancelledOrder(orderId).unwrap()
            // } else {
            //     await updateStatusOrder({ orderId, body: { status: selectedTypeOfUpdate } }).unwrap();
            // }
            await updateStatusOrder({ orderId, body: { status: selectedTypeOfUpdate } }).unwrap();
            showToast('Order status updated successfully', 'success')
            dispatch(clearTypeOfShowModalType())
            dispatch(clearSelectedId());
        } catch (error) {
            // showToast('Failed to update order status:', 'error')
            handleApiError(error, "Failed to update order status.");
        }
    }
    
    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'
        >
            <div className='relative w-[80%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[60%] lg:w-[35%]'>
                <div className='flex flex-col w-full'>
                    <div className='w-full space-y-3 py-5'>
                        {isLoadingOrderDetails ? (
                            <Loading />
                        ) : isErrorOrderDetails ? (
                            <ErrorMessage message='Something went wrong, please reload the page'/> 
                        ) : (
                            <>
                                <div className='flex flex-col p-1'>
                                    <div className='flex flex-col items-center justify-center mb-1'>
                                        <p className='text-[22px] md:text-[25px] lg:text-[27px] font-bold'>
                                            {dataOrderDetails?.orderID}
                                        </p>
                                        <p className='text-[12px] md:text-sm font-semibold text-gray-700'>
                                            {dataOrderDetails?.deceasedName}
                                        </p>
                                        <p className='text-[12px] md:text-sm font-medium text-gray-700'>
                                            {dataOrderDetails?.chapelName}
                                        </p>
                                        <p className="text-[12px] md:text-sm font-medium text-gray-700">
                                            {`${formatDate(dataOrderDetails?.createdAt ?? '')} - ${formatTime(dataOrderDetails?.createdAt ?? '')}`}
                                        </p>
                                    </div>
                                </div>

                                <div className='w-full'>
                                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:space-y-0"> 
                                        <Checkbox
                                            selectedTypeOfUpdate={selectedTypeOfUpdate}
                                            setSelectedTypeOfUpdate={setSelectedTypeOfUpdate}
                                            status={dataOrderDetails?.orderStatus ?? ''}
                                        />
                                    </div>
                                </div>
                                <hr className="h-px bg-gray-200 border-0" />
                            </>
                        )}
                        <div className='w-full flex space-x-2'>
                            {isErrorOrderDetails ? (
                                <div className='w-full flex justify-center'>
                                    <button 
                                        className='w-full bg-gray-400 text-white text-sm p-2 rounded hover:bg-gray-600 transition'
                                        onClick={handleCloseOrderUpdateModal}
                                    >
                                            Close
                                    </button>
                                </div>
                            ) : (
                                <>
                                    {isLoadingUpdateStatusOrder ? (
                                            <div className='flex bg-gray-300 justify-center w-full py-3 border rounded'>
                                                <Loading 
                                                    setH={'h-[15px]'} 
                                                    message='Updating...'
                                                    fontSize={'text-sm'}
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                <button 
                                                    className='w-1/2 bg-gray-400 text-white text-sm p-2 rounded transition'
                                                    onClick={handleCloseOrderUpdateModal}
                                                >
                                                    Close
                                                </button>
                                                <button 
                                                    className={`w-1/2 bg-cbColor text-white text-sm p-2 rounded transition ${!selectedTypeOfUpdate && 'cursor-not-allowed'}`}
                                                    onClick={() => {
                                                        if (dataOrderDetails?.orderID !== undefined) {
                                                            handleUpdateOrderStatus(dataOrderDetails.orderID);
                                                        }
                                                    }}
                                                    disabled={!selectedTypeOfUpdate}
                                                >
                                                    Update
                                                </button>  
                                            </>
                                        )
                                    }
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
